import { fromEvent, Observable } from 'rxjs';
import { share, filter } from 'rxjs/operators';

export const bodyClick$: Observable<any> = fromEvent(window.document.body, 'click')
  .pipe(share());

export const bodyKeydown$: Observable<any> = fromEvent(window.document.body, 'keydown')
  .pipe(share());

export const escape$: Observable<any> = bodyKeydown$
  .pipe(
    filter((e: KeyboardEvent) => e.keyCode === 27),
    share()
  );

export const enter$: Observable<any> = bodyKeydown$
  .pipe(
    filter((e: KeyboardEvent) => e.keyCode === 13),
    share()
  );

export const arrowUp$: Observable<any> = bodyKeydown$
  .pipe(
    filter((e: KeyboardEvent) => e.keyCode === 38),
    share()
  );

export const arrowDown$: Observable<any> = bodyKeydown$
  .pipe(
    filter((e: KeyboardEvent) => e.keyCode === 40),
    share()
  );
